import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  static targets = ["money"];

  connect() {
    this.applyMasks();
  }

  applyMasks() {
    this.moneyTargets.forEach((element) => {
      IMask(element, {
        mask: Number,
        scale: 2,
        thousandsSeparator: ".",
        radix: ",",
        padFractionalZeros: true,
        mapToRadix: ["."],
        normalizeZeros: true,
        signed: false,
        min: 0,
        // prefix corrige o problema
        prefix: "R$ ",
      });
    });
  }
}
